<template>
    <div class="page bg-gray page-flex">
        <appStatus :statusHeight="statusHeight"></appStatus>
        <div class="page-input-title" :style="{top:statusHeight+'rem'}">
            <div class="alifont icon-back left-icon click" @click="back"></div>
            <input type="search" @keyup.13="handleQuery" class="center-input fs-28" placeholder="搜索订单(手机号、订单号、顾客)"
                   v-model="pageInfo.queryKey">
            <div class="right fs-28 color-333 click" @click="handleQuery">
                搜索
            </div>
        </div>

        <div class="flex1 posi-rel pd-025 pb-25">
            <scroller ref="scroller" :on-refresh="loadNewData" :on-infinite="loadMore">
                <div class="card mt-20 pd-025 pt-25" v-for="(item,$index) in data" :key="$index">
                    <div class="flex-between fs-28 font-bold">
                        <div class="color-333">收货人：{{item.userName}}  <span class="ml-10">{{item.userMobile}}</span></div>
                        <div :class="item.orderStatus == 1?'color-333': item.orderStatus == 2? 'color-org': item.orderStatus == 3?'color-main':''">{{stutas[item.orderStatus]}}</div>
                    </div>
                    <div class="color-999 fs-24 mt-8">订单号：{{item.orderNo}}</div>
                    <div class="product-list">
                        <div class="product-item" v-for="(prod,$prodIndex) in item.productList">
                            <img :src="prod.imgPathView" alt="">
                            <div class="tips" v-if="prod.productQty >1">{{prod.productQty}}件</div>
                        </div>
                    </div>
                    <div class="mt-25 bd-top pd-250 flex-center" v-if="item.orderStatus == 2">
                        <div class="item-label">配送小区</div>
                        <div class="ml-10 fs-28 color-333 flex1">{{item.orgName}}</div>
                    </div>
                    <div class="mt-25 bd-top pd-250 flex-center" v-if="item.orderStatus == 3 || item.orderStatus == 1">
                        <div class="item-label">寄存柜</div>
                        <div class="ml-10 fs-28 color-333 flex1">{{item.orderShopName}}</div>
                        <div class="color-org fs-28">货道 {{item.wayCode}}</div>
                    </div>
                    <div class="bd-top pd-250 flex-between fs-28 color-333" v-if="item.orderStatus == 3 || item.orderStatus == 1">
                        <div>补货人：{{item.linkName}}</div>
                        <div>{{item.operateTime}}</div>
                    </div>
                </div>
            </scroller>
        </div>
    </div>
</template>

<script>
    import initData from "@/mixins/initData"
    import routerBack from "@/mixins/routerBack"
    import appStatus from "@/components/appStatus/index"
    import getAppStatusHeight from "@/mixins/getAppStatusHeight";
    export default {
        name: "lockerOrderList",
        mixins: [initData, routerBack, getAppStatusHeight],
        components: {appStatus},
        data(){
            return{
                stutas:{
                    1:'已完成',
                    2:'待配送',
                    3:'待取货',
                },
            }
        },
        created() {
            if(this.$route.query.keyWord){
                this.pageInfo.queryKey = this.$route.query.keyWord;
            }
        },
        methods:{
            back() {
                if (this.isBackClose) {
                    try {
                        window.native.onFinish();
                    } catch (e) {

                    }
                } else {
                    try {
                        window.native.onBack();
                    } catch (e) {
                        this.$router.go(-1)
                    }
                }
            },
            beforeInit() {
                this.params = { page : this.page, limit: this.limit,orgId:this.orgId};
                this.url = 'order/orderBase/qryOrgWayOrderList';
                let query = this.pageInfo;
                for (var key in query) {
                    if (query[key]) {
                        this.params[key] = query[key]
                    }
                }
                return true
            },

        }
    }
</script>

<style scoped lang="scss">
    .icon-xpsousuo{
        font-size: .48rem;
    }
    .icon-lujingbeifen{
        font-size: .22rem;
        color: #999;
    }
    .product-list{
        display: flex;
        flex-wrap: wrap;
        padding-top: .13rem;
        .product-item{
            position: relative;
            width: 1.2rem;
            height: 1.2rem;
            margin-top: .12rem;
            margin-right: .12rem;
            &:nth-child(5n){
                margin-right: 0;
            }
            .tips{
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: .32rem;
                text-align: center;
                line-height: .32rem;
                background: rgba(0,0,0,.6);
                color: #fff;
                font-size: .22rem;
            }
        }
    }
    .item-label{
        line-height: .36rem;
        height: .36rem;
        border-radius: .08rem;
        background: $main-color;
        padding: 0 .1rem;
        font-size: .26rem;
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// lockerOrderSearch.vue?183df545